import React from 'react';
import { string } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  IconButton, Drawer
} from '@one-thd/sui-atomic-components';
import { Email } from '@one-thd/sui-icons';
import { EmailListDrawerBody } from '../ListSettings/drawerBodies/EmailListDrawerBody';

export const EmailList = ({ listId, iconSize }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="sui-flex sui-justify-center" data-component="email-list">
      <IconButton iconSize={iconSize} icon={Email} alt="Email" aria-label="Email" onClick={handleOpen} />
      <Drawer open={open} onClose={handleClose}>
        <EmailListDrawerBody
          listId={listId}
          onClose={handleClose}
          menuName="Email List"
          hideBackButton
        />
      </Drawer>
    </div>
  );
};

EmailList.propTypes = {
  listId: string,
  iconSize: string,
};

EmailList.defaultProps = {
  listId: null,
  iconSize: 'small',
};

EmailList.displayName = 'EmailList';

EmailList.dataModel = extend(
  EmailListDrawerBody
);